export const SINGLE_ORDER_NUMBER_REG_EXP = /^BT[a-zA-Z0-9]{6,28}$/i;
export const GROUP_ORDER_NUMBER_REG_EXP = /^GBT[a-zA-Z0-9]{5,27}$/i;
export const POSTCODE_REG_EXP = /^[a-zA-Z]{1,2}[0-9]{1,2}[a-zA-Z]?[0-9][a-zA-Z]{2}$/i;
export const OCS_ORDER_NUMBER_REG_EXP = /^PX[a-zA-Z0-9-]{8,30}$/i;
